const VAR_QUERY_PARAM_PREFIX = 'var-';
function escapeCommas(value) {
    return value.replace(/,/g, '\\,');
}
function encodeVariableValue(value) {
    if (Array.isArray(value)) return value.join(',');
    return escapeCommas(value ?? '');
}
const INTERVAL_VARIABLE_AUTO_VALUE = '__auto';
const DEFAULT_INTERVAL_VARIABLE_OPTIONS = [
    '1m',
    '5m',
    '10m',
    '30m',
    '1h',
    '6h',
    '12h',
    '1d',
    '7d',
    '14d',
    '30d'
];
const DEFAULT_INTERVAL_VARIABLE_RESOLUTION = 'Medium';
const DEFAULT_MIN_INTERVAL_SIZE = '1m';
function isListVariableDefinition(variable) {
    return variable?.kind === 'ListVariable';
}
export { DEFAULT_INTERVAL_VARIABLE_OPTIONS, DEFAULT_INTERVAL_VARIABLE_RESOLUTION, DEFAULT_MIN_INTERVAL_SIZE, INTERVAL_VARIABLE_AUTO_VALUE, VAR_QUERY_PARAM_PREFIX, encodeVariableValue, isListVariableDefinition };

//# sourceMappingURL=variables.js.map